'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Category {
  id: string;
  name: string;
  count: number;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-subtle">
      <h3 className="font-headline font-semibold text-lg text-foreground mb-4 flex items-center">
        <Icon name="FunnelIcon" size={20} className="mr-2 text-primary" />
        Categories
      </h3>
      <div className="space-y-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`w-full text-left px-4 py-3 rounded-md font-body transition-brand flex items-center justify-between ${
              activeCategory === category.id
                ? 'bg-primary text-primary-foreground shadow-brand'
                : 'bg-background hover:bg-muted text-foreground'
            }`}
          >
            <span className="font-medium">{category.name}</span>
            <span
              className={`text-sm px-2 py-1 rounded-full ${
                activeCategory === category.id
                  ? 'bg-white/20 text-white' :'bg-muted text-muted-foreground'
              }`}
            >
              {category.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;